import httpClient from "../http-client/client";

export default class users {
  //get operator  service
  getAgents = () => {
    return httpClient.get("/status/AgentStaus");
  };
  sendMessage=(data)=>{
    return httpClient.post("/refer/sendFcm",data);
  };
}
